module.exports = __webpack_public_path__ + "static/media/light-switch.7207e967.svg";